module.exports = __webpack_public_path__ + "img/empty.f5d3c82c.png";